import BaseRoute from "../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../lib/itn-ui-kit/services/service-container.js";
import { loadDocumentData } from "../../components/modules/documentsListView/utils/document-loader-helpers";

import Template from "./template";

export default class DocumentSearchRoute extends BaseRoute {
  @service("repositories/document-repository") documentRepository;

  element = (<Template />);

  async loader({ request }) {
    const url = new URL(request.url);
    const searchParams = Object.fromEntries(url.searchParams.entries());

    return await loadDocumentData({
      documentRepository: this.documentRepository,
      searchParams,
    });
  }
}
